import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Membership.css";
import HeroSection from "../HeroSection";
import Register from "../Register";
import Offer from "../Offer";
import Newsletter from "../Newsletter";
import Footer from "../Footer";
import VideoModal from "../VideoModal";
import aboutImage from "./assets/about-us-image.jpg";
import playIcon from "./assets/svg/status-play.svg";

const Membership = () => {
  const [videoOpen, setVideoOpen] = useState(false);
  return (
    <main className="membership-page">
      {videoOpen && <VideoModal onClose={() => setVideoOpen(false)} />}
      <HeroSection
        title="Nem vagy egyedül. Együtt könnyebb a beszéd."
        text="Csatlakozz közösségünkhöz, ahol megértés, támogatás és fejlődési lehetőség vár. Legyél részese egy olyan csapatnak, ahol minden hang számít."
        customVisual={
          <div className="membership-video-placeholder">
            <div className="membership-video-bottom"></div>
            <div
              className="membership-video-top"
              onClick={() => setVideoOpen(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") setVideoOpen(true); }}
              style={{ cursor: "pointer", zIndex: 100, position: "absolute" }}
            >
              <img src={playIcon} alt="Lejátszás" className="membership-video-play" style={{ pointerEvents: "none" }} />
            </div>
          </div>
        }
      />
      <Register />

      <section className="about-us-section">
        <div className="about-us-container">
          {/* Desktop: image on left */}
          <div
            className="about-us-image about-us-image--desktop"
            style={{ backgroundImage: `url(${aboutImage})` }}
          ></div>
          <div className="about-us-text">
            <h2 className="heading-md">Kik vagyunk?</h2>
            <p>
              Olyan dadogó érintettek vagyunk, akik aktívan szeretnénk tenni önmagunkért és egymásért. Megjeleníteni a dadogó emberek hangját, hogy minél több érintett találjon támogató közösségre nálunk. Alakítani a társadalom elképzeléseit és hozzáállását a dadogáshoz.
            </p>
            {/* Mobile: image between text and button */}
            <div
              className="about-us-image about-us-image--mobile"
              style={{ backgroundImage: `url(${aboutImage})` }}
            ></div>
            <Link to="/about" className="button-secondary">Olvass rólunk többet</Link>
          </div>
        </div>
      </section>

      <section className="membership-offer">
        <Offer />
      </section>
      <Newsletter twoColumn={true} />
      <Footer />
    </main>
  );
};

export default Membership;